(function() {
    'use strict';
    var trackingUtils = require('../modules/utils/tracking.utils');
    var tagManagement = require('../modules/utils/tag_management.utils');

    Odigeo.Router.handlers.inspirational = function() {
        var searchParams = JSON.parse(Odigeo.Session.get('searchParameters'));
        var searchParamsIsObject = _.isObject(searchParams);

        Odigeo.Router.eventController = $.extend(true,
            Odigeo.Router.eventController,
            Odigeo.Router.handlers.userEventController,
            Odigeo.Router.handlers.searchFlightsEventController);

        Odigeo.Router.eventController.execute();

        Odigeo.requireWidget('inspirational-manager', 'inspirational_manager', function(inspirationalmanager) {
            if (inspirationalmanager.execute('isLoaded') || searchParamsIsObject) {
                if (searchParamsIsObject && (searchParams.triggerInspirationalSearch || searchParams.isInspirationalSearch)) {
                    inspirationalmanager.execute('setSearchParams', searchParams);
                }
            } else {
                Odigeo.Router.navigate('home', {replace: true});
            }
        });

        // Analytics: virtual page tracking
        trackingUtils.trackPage('inspirational', {
            funnel: false,
        });
        tagManagement.updateDatalayer();
    };
}());
